import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Api } from '@services';

export default function AssetDownloadPage() {
  const location = useLocation();

  // Grab the last non-empty part of the path
  const exportId = useMemo(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    return parts[parts.length - 1] || null;
  }, [location.pathname]);

  useEffect(() => {
    if (!exportId) return;

    const download = async () => {
      try {
        const res = await Api.get(`/v2/assets/filter/background-export/${exportId}`, {
          responseType: 'blob',
        });

        if (res.status !== 200) {
          console.error('Export not ready yet:', res.status);
          return;
        }

        const dispo = res.headers['content-disposition'] || '';
        const match = dispo.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
        const filename = decodeURIComponent(match?.[1] || `Asset_Export.csv`);

        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('Download failed', e);
      }
    };

    download();
  }, [exportId]);

  return <div className="container py-5 text-center">Starting your download…</div>;
}
